var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "secondary-nav" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v("\n      " + _vm._s(_vm._f("trans")("Choose Style")) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c("router-link", {
            attrs: { to: { name: "JobCanvas", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn-back btn text-white font-weight-bold",
                        on: { click: navigate },
                      },
                      [
                        _c("i", {
                          staticClass: "fa lh-inherit fa-chevron-left",
                        }),
                        _vm._v(
                          " " + _vm._s(_vm._f("trans")("Back")) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "p-20 justify-content-center d-flex" }, [
      _c("div", { staticClass: "content-container" }, [
        _c(
          "div",
          { staticClass: "style-group" },
          [_c("style-description"), _vm._v(" "), _c("style-selector")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }